<template>
  <div id="find-space-modal" class="modal-container" :class="{visible: visible}">
    <div class="modal wholescreen" :class="{visible: visible}" @click.stop>
      <div class="find-space-container">
        <Nav @closeModal="hide"/>
        <vue-simplebar class="findspace-content-scrollable">
          <div>
            <FindSpaceHome @closeModal="hide" v-if="page == 'home'"/>
            <template v-if="page == 'shortlists'">
              <ShortlistsDashboard @closeModal="hide" v-if="subpage == 'home'" />
              <ShortlistsView @closeModal="hide" v-if="subpage == 'view'" />
              <ShortlistsLookbooks @closeModal="hide" v-if="subpage == 'lookbooks'" />
            </template>
            <template v-if="page == 'account'">
              <Account @closeModal="hide" v-if="subpage == 'account'" />
            </template>
            <template v-if="page == 'bookings'">
              <BookingsDashboard @closeModal="hide" v-if="subpage == 'home'" />
              <BookingsView @closeModal="hide" v-if="subpage == 'view'" />
            </template>
            <template v-if="page == 'briefs'">
              <BriefsDashboard @closeModal="hide" v-if="subpage =='home'" />
              <BriefsAdd @closeModal="hide" v-if="subpage == 'create'" />
            </template>
            <template v-if="page == 'listings'">
              <ListingsDashboard v-if="subpage == 'home'" />
            </template>
          </div>
        </vue-simplebar>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from './partials/Nav.vue';
import FindSpaceHome from './FindSpaceHome.vue';
import ShortlistsDashboard from './partials/shortlist/Dashboard';
import ShortlistsView from './partials/shortlist/View';
import ShortlistsLookbooks from './partials/shortlist/Lookbooks';
import Account from './partials/account/Account';
import BookingsDashboard from './partials/bookings/Dashboard';
import BookingsView from './partials/bookings/View';
import BriefsDashboard from './partials/briefs/Dashboard';
import BriefsAdd from './partials/briefs/Add';
import ListingsDashboard from './partials/listings/Dashboard';

export default {
  components: {
    Nav,
    FindSpaceHome,
    ShortlistsDashboard,
    ShortlistsView,
    ShortlistsLookbooks,
    Account,
    BookingsDashboard,
    BookingsView,
    BriefsDashboard,
    BriefsAdd,
    ListingsDashboard
  },
  methods: {
    hide () {
      if(window.location.href.includes("#find-your-space-today")) {
        window.history.pushState("state obj or string", "url", window.location.href.substring(0, window.location.href.indexOf('#')));
      }
      this.$store.commit('findspace/hide')
    },
  },
  computed: {
    visible () {
      return this.$store.getters['findspace/visible']
    },
    user () {
      return this.$store.getters['user/account']
    },
    page () {
      return this.$store.getters['findspace/page']
    },
    subpage () {
      return this.$store.getters['findspace/subpage']
    },
  },
  mounted() {

  }
}
</script>

